<template>
  <div @click="$emit('select')" class="metric px1 py2 grow">
    <div class="row_height flex justify_center">
      <h4 class="mya">
        <animated-number
          style="font-size: 26px"
          :value="displayValue"
          :randomStartsAt="metric.placeholder"
          :format="metric.format"
        /><span
        style="margin-left: -6px"
        class="medium light"
        v-if="metric.suffix"
      >{{ metric.suffix }}</span>
      </h4>
    </div>

    <div class="row_height flex justify_center mb1">
      <h4 class="mya">{{ $t(metric.text) }}</h4>
    </div>

    <circle-button
      v-if="clickable"
      @click="clickable && $emit('select')"
      :color="metric.color"
      :fill="selected"
    ></circle-button>
    <icon :size="24" class="mxa" v-if="metric.icon" :icon-name="metric.icon"/>
  </div>
</template>

<script>
export default {
  name: 'metric',

  props: {
    metric: Object,
    value: Number,
    selected: Boolean,
    clickable: Boolean,
  },

  computed: {
    displayValue() {
      return this.value ? Math.round(this.value * 100) / 100 : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  .row_height {
    height: 30px;
  }

  .metric {
    width: 100%;
    text-align: center;
  }
</style>
